<template>
  <SimpleDataTable
      :clickable-title="true"
      :title="'Satış Faturası Raporu'"
      :description="''"
      :dataList="saleReportData"
      :dataHeaders="saleReportHeaders"
      :loading="saleReportDataLoading"
      :currencyAmountProp="saleCurrencyAmountProp"
  >
    <template v-slot:filterAndAction>

      <v-select
          v-model="saleReportTimePeriodFilterValue"
          :items="[
                      {value: 5, text: 'Tarih Aralığı'},
                      {value: 4, text: 'Yıllık'},
                      {value: 3, text: 'Aylık'},
                      {value: 2, text: 'Haftalık'},
                      {value: 1, text: 'Günlük'}
                  ]"
          style="width:100px;margin: 0 3px"
          label=""
          item-text="text"
          item-value="value"
          filled
          solo
          hide-details
          dense
          @change="saleReportTimePeriodFilterValue !== 5  ? _fetchSaleReport : null"
      >

      </v-select>
      <div v-if="saleReportTimePeriodFilterValue === 5">
        <v-menu
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
                :value="formattedDate(saleReportDateRangeStartFilterValue)"
                placeholder="Filtre Başlangıç Tarihi"
                class="m-1"
                readonly
                filled
                solo
                dense
                clearable
                @click:clear="saleReportDateRangeStartFilterValue = null"
                hide-details
                v-bind="attrs"
                v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
              v-model="saleReportDateRangeStartFilterValue"
              locale="tr"
              :max="saleReportDateRangeEndFilterValue ? saleReportDateRangeEndFilterValue : 'NaN-Nan-Nan'"
          ></v-date-picker>
        </v-menu>
        <v-menu
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
                :value="formattedDate(saleReportDateRangeEndFilterValue)"
                placeholder="Filtre Bitiş Tarihi"
                readonly
                solo
                filled
                class="m-1"
                dense
                clearable
                @click:clear="saleReportDateRangeEndFilterValue = null"
                hide-details
                v-bind="attrs"
                v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
              v-model="saleReportDateRangeEndFilterValue"
              locale="tr"
              :min="saleReportDateRangeStartFilterValue"
          ></v-date-picker>
        </v-menu>
        <div class="w-100 text-center">
          <v-btn
              x-small
              class="mx-auto"
              color="primary darken-2"
              @click="_fetchSaleReport"
          >
            FİLTRELE
          </v-btn>
        </div>

      </div>

    </template>

    <template v-slot:vatExcludedCurrencyAmount>
    </template>
  </SimpleDataTable>
</template>

<script>

import SimpleDataTable from "@/components/dashboard/SimpleDataTable";
import {formattedDate} from "@/momentHelper";
import {numberConverter} from "../../../../helpers";
import {mapActions, mapState} from "vuex";

export default {
  name: "SatisFaturasiRaporu",
  components: {
    SimpleDataTable
  },
  props:{
    dashboardFilterCurrentCodeProp: {
      type: String,
      default: null
    },
    dashboardFilterSalesPersonCodeProp: {
      type: String,
      default: null
    },
    dashboardFilterReportDbNameProp: {
      type: String,
      default: null
    }
  },
  computed: {
    ...mapState("settings", ["erpSettings"]),
    ...mapState("auth",["user"])
  },
  mounted(){
    this._fetchSaleReport()
  },
  data(){
    return {
      saleReportHeaders:[],
      saleReportData:[],
      saleReportDataLoading: false,
      saleReportTimePeriodFilterValue: 4,
      saleReportDateRangeStartFilterValue: null,
      saleReportDateRangeEndFilterValue: null,
      saleCurrencyAmountProp: [],
    }
  },
  methods: {
    ...mapActions("dashboard", ["fetchSaleReport","fetchCurrencySaleReport", "prepareCurrencyAmount"]),
    formattedDate,
    numberConverter,
    async _fetchSaleReport() {
      this.saleReportDataLoading = true;
      const requestData = {
        params: {
          userId: this.user.UserId,
        },
        body: {
          ...(!(this.dashboardFilterCurrentCodeProp === "" || this.dashboardFilterCurrentCodeProp == null)) && {
            currentCode: this.dashboardFilterCurrentCodeProp,
          },
          ...(!(this.dashboardFilterSalesPersonCodeProp === "" || this.dashboardFilterSalesPersonCodeProp == null)) && {
            salesPersonCode: this.dashboardFilterSalesPersonCodeProp,
          },
          ...(!(this.dashboardFilterReportDbNameProp === "" || this.dashboardFilterReportDbNameProp == null)) && {
            reportDbName: this.dashboardFilterReportDbNameProp,
          },
          ...(!(this.saleReportTimePeriodFilterValue === "" || this.saleReportTimePeriodFilterValue == null)) && {
            DateType: this.saleReportTimePeriodFilterValue,
          },
          Type: 1,
        },
      };

      if (this.saleReportTimePeriodFilterValue === 5) {
        requestData.body.startDate = this.saleReportDateRangeStartFilterValue;
        requestData.body.endDate = this.saleReportDateRangeEndFilterValue;
      }

      await this.fetchSaleReport(requestData).then(async (result) => {
        if (result && result.data.success) {
          this.saleReportData = [];
          this.saleReportData.push(result.data.data);
          this.saleReportData.map((item) => (item.vatExcludedAmount = this.numberConverter(item.vatExcludedAmount)));
          this.saleReportHeaders = [
            {
              key: 'vatExcludedAmount',
              label: 'Tutar (TL)',
              sortable: false,
              class: 'text-left'
            },
          ]
          if (this.erpSettings.netsisCurrencySale) {
             await this.fetchCurrencySaleReport(requestData).then(async (result) => {
               if (!result) {
                 this.purchaseReportDataLoading = false;
                 return;
               }
              result.data.data.map((item) => {
                this.saleReportHeaders.push({
                  key: item.currencyName,
                  label: item.currencySymbol,
                  sortable: false,
                  class: 'text-center pe-4'
                })
                let keytemp = `${item.currencyName}`;
                item[keytemp] = item.vatExcludedAmount;
                delete item.vatExcludedAmount;
                let existingItem = this.saleReportData[0];
                if (existingItem) {
                  existingItem[item.currencyName] = this.numberConverter(item[keytemp]);
                } else {
                  let newObj = {
                    [item.currencyName]: item[keytemp]
                  };
                  this.saleReportData.push(newObj);
                }
              });
               this.saleReportData.push(result.data.data);
            })
          }
        }

        this.saleReportDataLoading = false;
      });
    },
//     rename(param) {
//       console.log(param);
//       param = param.map(function (obj) {
//
//     // Assign new key
//     obj['vatExcludedAmount'] = obj['USD'];
//
//     // Delete old key
//     delete obj['vatExcludedAmount'];
//         console.log(obj)
//     return obj;
//   });
// },
    fetchSaleReportDefault() {
      this._fetchSaleReport();
    },
    fetchSaleReportCustomPeriod() {
      this._fetchSaleReport(true);
    },
  },

  watch: {
    dashboardFilterCurrentCodeProp(newVal){
      newVal;
      this._fetchSaleReport()
    },
    dashboardFilterSalesPersonCodeProp(newVal){
      newVal;
      this._fetchSaleReport()
    },
    dashboardFilterReportDbNameProp(newVal){
      newVal;
      this._fetchSaleReport()
    },
    saleReportTimePeriodFilterValue(newVal){
      if (newVal === 5) return;
      this._fetchSaleReport()
    },

  }
}
</script>

<style scoped>

</style>